import ReactJoyride from "react-joyride";
import CustomTooltip from "./CustomTooltip";
import React from "react";
import { VIEW_ROLE } from "../../../query/ViewRole";
import { useQuery } from "@apollo/react-hooks";
import { hasuraClient } from "../../../apolloClient";

export default function TourMain() {
  const { data: userRole } = useQuery(VIEW_ROLE, {
    variables: {
      userId: localStorage.getItem("user_id"),
    },
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });
  const steps = [
    {
      target: ".tour-dashboard",
      content:
        "The Dashboard will show your business’ performace including ticket income, latest transactions and others.",
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-posts",
      content:
        "Create a Post here to communicate with your customers. You could also view and manage all your published and upcoming posts.",
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-deals",
      content:
        "Create deals as well as manage your active and expire ones. On this Deals page, you are also able to view the performance of a specific deal.",
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-events",
      content:
        "The Events page allows you to create events for your customers to attend. Here you could also view the performace of a specific event based on shares, attendees and others.",
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-profile",
      content:
        "View, manage and make changes to your business profile. Here you can edit the details of your business as well as view and moderate all existing posts, events, deals, and reviews.",
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-add",
      content:
        "Use this to quickly add a new post, event or deal for your customers.",
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-add",
      content:
        "Use this to quickly add a new post, event or deal for your customers.",
      disableBeacon: true,
      placement: "right-start",
    },
  ];
  const clubsteps = [
    {
      target: ".tour-dashboard",
      content:
        "The Dashboard will show your club performace including ticket income, latest transactions and others.",
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-posts",
      content:
        "Create a Post here to communicate with your customers. You could also view and manage all your published and upcoming posts.",
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-deals",
      content:
        "Create deals as well as manage your active and expire ones. On this Deals page, you are also able to view the performance of a specific deal.",
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-events",
      content:
        "The Events page allows you to create events for your customers to attend. Here you could also view the performace of a specific event based on shares, attendees and others.",
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-profile",
      content:
        "View, manage and make changes to your club profile. Here you can edit the details of your club as well as view and moderate all existing posts, events, deals, and reviews.",
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-add",
      content:
        "Use this to quickly add a new post, event or deal for your customers.",
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-add",
      content:
        "Use this to quickly add a new post, event or deal for your customers.",
      disableBeacon: true,
      placement: "right-start",
    },
  ];

  return userRole?.users[0].role==="business"?
    <ReactJoyride
      steps={steps}
      run={true}
      continuous={true}
      spotlightPadding={0}
      disableScrolling={true}
      hideCloseButton={true}
      tooltipComponent={CustomTooltip}
    />:<ReactJoyride
    steps={clubsteps}
    run={true}
    continuous={true}
    spotlightPadding={0}
    disableScrolling={true}
    hideCloseButton={true}
    tooltipComponent={CustomTooltip}
  />
  
}
